<div
  class="container"
  [ngStyle]="{ 'max-height': maxHeight(), 'max-width': maxWidth() }">
  <div
    class="fv-basic"
    [ngClass]="{ needsColumn: needsColumn() }">
    @if (image) {
      <div class="fv-image">
        <div></div>
        <video
          [src]="image"
          [ngStyle]="{ 'max-width': imageMaxWidth() }"
          [controls]="false"
          [autoplay]="true"
          [loop]="true">
          <source
            type="video/mov"
            [src]="image" />
        </video>
        <div></div>
        <!-- <img aria-label="first user experience gif" *ngIf="image" [src]="image"/> -->
      </div>
    }
    @if (text) {
      <div class="fv-text">
        <h3>{{ text.headline | translate }}</h3>
        <p [innerHTML]="text.text | translate"></p>
      </div>
    }
  </div>
</div>
